export type VideoCardData = {
  title: string;
  description?: string;
  coverLandscapeUrl?: string;
  coverPortraitUrl?: string;
  layout: "landscape" | "portrait";
  featured?: boolean;
  durationSeconds?: number | null;
};

function fmt(s: number | null | undefined): string {
  if (!s) return "";
  return `${Math.max(1, Math.round(s / 60))} min`;
}

/**
 * Tarjeta de video. La usan la comunidad (lo que ve el socio) y la vista previa del admin,
 * así lo que ves al configurar es exactamente lo que se publica.
 * Horizontal = portada 16:9. Vertical = portada 4:5.
 */
export default function VideoCard({ video, onClick, className = "" }: { video: VideoCardData; onClick?: () => void; className?: string }) {
  const portrait = video.layout === "portrait";
  const cover = portrait ? video.coverPortraitUrl || video.coverLandscapeUrl : video.coverLandscapeUrl || video.coverPortraitUrl;
  const meta = [fmt(video.durationSeconds), video.description].filter(Boolean).join(" · ");
  const Tag = onClick ? "button" : "div";
  return (
    <Tag
      {...(onClick ? { onClick, type: "button" as const } : {})}
      className={`text-left block w-full rounded-2xl overflow-hidden bg-background-50 border border-background-200 ${onClick ? "hover:border-primary-300 cursor-pointer" : ""} ${className}`}
    >
      <div className="relative w-full bg-gradient-to-br from-primary-600/90 to-accent-600/80" style={{ aspectRatio: portrait ? "4 / 5" : "16 / 9" }}>
        {cover ? <img src={cover} alt="" className="absolute inset-0 w-full h-full object-cover" loading="lazy" /> : null}
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="w-12 h-12 rounded-full bg-black/45 text-white flex items-center justify-center backdrop-blur-sm">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </span>
        {video.featured ? (
          <span className="absolute top-2 left-2 text-[10px] font-bold uppercase tracking-wide bg-amber-400 text-amber-950 px-2 py-0.5 rounded-full">Destacado</span>
        ) : null}
        {video.durationSeconds ? (
          <span className="absolute bottom-2 right-2 text-[10px] font-semibold bg-black/60 text-white px-1.5 py-0.5 rounded">{fmt(video.durationSeconds)}</span>
        ) : null}
      </div>
      <div className="p-3">
        <div className="font-semibold text-sm text-foreground-950 leading-snug line-clamp-2">{video.title || "Título del video"}</div>
        {meta ? <div className="mt-0.5 text-[11px] text-foreground-500 line-clamp-2">{video.description || ""}</div> : null}
      </div>
    </Tag>
  );
}
